(function(APP, $, window, document) {
	'use strict';

	function SingleFormation(options) {
		if (!(this instanceof SingleFormation)) return new SingleFormation(options);

		Vue.use(VueAwesomeSwiper);

		for (var i = 0; i < sessions.length; i++) {
			sessions[i].dates.start = new Date(sessions[i].dates.start);
			sessions[i].dates.end = new Date(sessions[i].dates.end);
		}

		new Vue({
		  el: '.vue-calendar',
		  data: {
				formation: formation,
				formation_selected_text: '',
				centers: centers,
				centers_checked: [],
				sessions: sessions,
				calendars: [],
				firstDayOfWeek: 2,
				minDate: new Date(),
				maxDate: new Date(),
				navVisibility: 'hidden',
				submit_btn: null,
				session_id: null,
				swiperOption: {
					initialSlide: 0,
					allowTouchMove: false,
					slidesPerView: 3,
					breakpoints: {
				    // when window width is <= 767
				    767: {
				      slidesPerView: 1,
				      spaceBetween: 0,
				    },
				    // when window width is <= 991
				    1279: {
				      slidesPerView: 2,
							spaceBetween: 0,
				    },
				    4000: {
							slidesPerView: 3,
							spaceBetween: 0,
				    },
				  },
	        navigation: {
						prevEl: '.swiper__button--prev',
	          nextEl: '.swiper__button--next',
	        },
				},
		  },
			created: function () {

				for (var i = 0; i < this.centers.length; i++) {
					this.centers_checked.push(this.centers[i].id);
				}
				var calendars = this.getCalendarsByCenters(this.centers_checked, $.extend(true, [], this.sessions));

				this.minDate = calendars.start;
				this.maxDate = calendars.end;
				this.calendars = calendars.list;

				// On boucle sur tous les calendriers pour trouver celui qui est le mois en cours et afficher en premier le calendrier correspondant
				for (var i = 0; i < calendars.list.length; i++) {

					if (this.getPositionOfTimeBy('month', new Date(), calendars.list[i].minDate) === 0) {
						this.swiperOption.initialSlide = i;
					}
				}
			},
			methods: {
				submitClick: function (event) {
					if (!this.session_id) {
						return false;
					}
					window.location.href = '/demande-dinscription/' + this.session_id;
				},
				dayClick: function (date) {

					// On vérifie que sur le jour qu'on a cliqué il y a bien une session
					if (!date.attributes.length) {
						return false;
					}

					// On cherche l'index de la première session qui n'est pas encore passé
					// Et on vérifie aussi si elle à bien une "session_id"
					var index;
					for (var i = 0; i < date.attributes.length; i++) {
						if (!date.attributes[i].customData.is_past && typeof date.attributes[i].customData.session_id === 'number') {
							index = i;
						}
					}

					if (typeof index !== 'number') {
						return false;
					}

					var session_data = date.attributes[index].customData;
					var session_id = session_data.session_id;

					if (session_id === this.session_id) {
						session_id = false;
					}

					if (session_id) {
						this.session_id = session_id;
					} else {
						this.session_id = null;
					}

					var date_format_options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};

					if (this.formation.duration) {

						this.formation_selected_text = 'La formation du ';

						if (this.formation.duration > 1) {

							this.formation_selected_text += '<strong class="f-blue-darker">' + new Date(session_data.dates_full[0].day_date).toLocaleDateString('fr-FR', date_format_options) + '</strong>';
							this.formation_selected_text += ' au ';
							this.formation_selected_text += '<strong class="f-blue-darker">' + new Date(session_data.dates_full[session_data.dates_full.length - 1].day_date).toLocaleDateString('fr-FR', date_format_options) + '</strong>';

						} else {
							this.formation_selected_text += '<strong class="f-blue-darker">' + new Date(session_data.dates_full[0].day_date).toLocaleDateString('fr-FR', date_format_options) + '</strong>';
						}

					} else if (this.formation.duration_mode === 'HOURS') {

						this.formation_selected_text = 'La formation du ';

						if (session_data.dates_full.length > 1) {

							this.formation_selected_text += '<strong class="f-blue-darker">' + new Date(session_data.dates_full[0].day_date).toLocaleDateString('fr-FR', date_format_options) + '</strong>';
							this.formation_selected_text += ' au ';
							this.formation_selected_text += '<strong class="f-blue-darker">' + new Date(session_data.dates_full[session_data.dates_full.length - 1].day_date).toLocaleDateString('fr-FR', date_format_options) + '</strong>';

						} else {
							this.formation_selected_text += '<strong class="f-blue-darker">' + new Date(session_data.dates_full[0].day_date).toLocaleDateString('fr-FR', date_format_options) + '</strong>';
						}
					}

					var _centers = centers.filter(function(center) {
						return (center.id === session_data.center_id) ? true : false;
					});

					if (_centers.length) {
						this.formation_selected_text += ' à <strong class="f-blue-darker">' + _centers[0].label + '</strong>';
					}

					if (!session_id) {
						this.formation_selected_text = '';
					}

					// On recharge les calendriers mais en metant la session choisis en "sélectionné"
					var _calendars = this.getCalendarsByCenters(this.centers_checked, this.sessions);

					this.calendars = _calendars.list;
					this.minDate = _calendars.start;
					this.maxDate = _calendars.end;
				},
				updateCenters: function (event) {

					var _calendars = this.getCalendarsByCenters(this.centers_checked, this.sessions);

					this.calendars = _calendars.list;
					this.minDate = _calendars.start;
					this.maxDate = _calendars.end;
				},
				getCalendarsByCenters: function(centers, sessions) {
					var sessions = sessions.slice();
					/*
					 * Ici nous allons générer autant de calendrier qu'il faut pour aller du début de la première session à la fin de la dernière session
					 *
					 * L'idée est d'abord de bouclé sur toutes les sessions pour voir la plus petite et la plus grande date.
					 * Ensuite on calcule le nombre de mois qu'il y a entres ces 2 dates
					 * Puis on créer un tableau pour chaque mois comportant les dates de sessions en prenant le soins de dire à chaque tableau de n'afficher que le mois auquel il est attribué
					 */

					// On créer en premier la tableaux qui comportera les calendriers
					var new_sessions = []

					// On crée les dates minimum et maximum
					var calendar_start = new Date()
					var calendar_end = new Date()

					// On crée la variables contenant le nombre de mois (calendriers) affichés
					var calendar_count = 0

					for (var i = 0; i < sessions.length; i++) {
						// On bloucle toutes les sessions et on met à jour les dates minimum et maximum
						calendar_start = (sessions[i].dates.start < calendar_start) ? sessions[i].dates.start : calendar_start;
						calendar_end = (sessions[i].dates.end > calendar_end) ? sessions[i].dates.end : calendar_end;

						// On met à jour la variable 'is_selected' à la session si elle est actuellement renseigné dans le champs input
						sessions[i].customData.is_selected = (sessions[i].customData.session_id === this.session_id) ? true : false;
					}

					// On reboucle sur les sessions pour changer le style d'affichage des sessions (highlight)
					for (var i = 0; i < sessions.length; i++) {

						if (this.getPositionOfTimeBy('day', new Date(), sessions[i].dates.start) <= 0) {

							sessions[i].customData.is_past = true;
							sessions[i].customData.color = '#ccc';
							sessions[i].highlight.borderColor = '#ccc';
							sessions[i].highlight.backgroundColor = 'transparent';
							sessions[i].contentStyle = {color: '#ccc'};
						} else {

							if (sessions[i].customData.is_selected) {
								sessions[i].highlight.backgroundColor = sessions[i].customData.color;
								sessions[i].contentStyle = {color: '#fff'};
							} else {
								sessions[i].highlight.backgroundColor = 'transparent';
								sessions[i].contentStyle = {color: sessions[i].customData.color};
							}

							sessions[i].contentStyle = function(date) {

								if (date.isHovered && this.customData.is_selected) {

									return {
										border: '1px solid #fff',
										color: '#fff',
										backgroundColor: this.customData.color,
										cursor: 'pointer',
									};

								} else if (!date.isHovered && this.customData.is_selected) {

									return {
										border: '0 solid transparent',
										color: '#fff',
										backgroundColor: 'transparent',
										cursor: 'pointer',
									};

								} else if (date.isHovered && !this.customData.is_selected) {

									return {
										border: '1px solid #fff',
										color: '#fff',
										backgroundColor: this.customData.color,
										cursor: 'pointer',
									};

								} else if (!date.isHovered && !this.customData.is_selected) {

									return {
										border: '0 solid transparent',
										color: this.customData.color,
										backgroundColor: 'transparent',
										cursor: 'pointer',
									};
								}
							}.bind(sessions[i]);
						}
					}

					// On met à jour la variables contenant le nombre de mois
					// (on ajoute 2 mois, parce que la fonction calcule la différence entre les 2 dates)
					calendar_count = this.monthDiff(calendar_start, new Date(calendar_end.getFullYear()+'-12')) + 2;

					// On crée une boucle sur le nombre de mois à afficher
					// pour créer un tableau comportant toutes les dates pour chaques calendrier en prenant soins de restreindre l'affiche des calendriers sur 1 mois
					for (var i = 0; i < calendar_count; i++) {

						var min_date = new Date(calendar_start.getFullYear(), calendar_start.getMonth() + i, 1);
						var max_date = new Date(calendar_start.getFullYear(), calendar_start.getMonth() + i + 1, 0);

						sessions = sessions.filter(function(date) {
							var in_array = false;
							for (var i = 0; i < centers.length; i++) {
								if (centers[i] === date.customData.center_id) {
									in_array = true;
								}
							}
							return in_array;
						});

						new_sessions.push({
							minDate: min_date,
							maxDate: max_date,
							dates: sessions,
						});
					}

					return {
						list: new_sessions,
						start: calendar_start,
						end: calendar_end,
					}
				},
				monthDiff: function(d1, d2) {
					var months;
					months = (d2.getFullYear() - d1.getFullYear()) * 12;
					months -= d1.getMonth() + 1;
					months += d2.getMonth();
					return months <= 0 ? 0 : months;
				},
				getDatesBetweenTwoDates: function(sessions, date_start, date_end) {
					var new_dates = [];

					if (typeof sessions !== 'object' || !sessions || typeof date_start !== 'object' || !date_start || typeof date_end !== 'object' || !date_end) {
						return new_dates;
					}

					for (var i = 0; i < sessions.length; i++) {

						if (sessions[i].dates.start > date_start || sessions[i].dates.end < date_end) {
							new_dates.push(sessions[i]);
						}
					}

					return new_dates;
				},
				getPositionOfTimeBy: function(by, date_1, date_2) {

					if (by === 'year') {

						var _date_1 = new Date(date_1.getFullYear());
						var _date_2 = new Date(date_2.getFullYear());

					} else if (by === 'month') {

						var _date_1 = new Date(date_1.getFullYear()+'-'+(date_1.getMonth() + 1));
						var _date_2 = new Date(date_2.getFullYear()+'-'+(date_2.getMonth() + 1));

					} else {
						var _date_1 = new Date(date_1.getFullYear()+'-'+(date_1.getMonth() + 1)+'-'+(date_1.getDate() + 1));
						var _date_2 = new Date(date_2.getFullYear()+'-'+(date_2.getMonth() + 1)+'-'+(date_2.getDate() + 1));
					}

					return (_date_2.getTime() < _date_1.getTime()) ? -1 : (_date_2.getTime() === _date_1.getTime()) ? 0 : 1;
				},
			},
		})

		return this;
	}

	$(window).on('load', function() {
		APP.store.singleFormation = new SingleFormation();
	});

})(APP, jQuery, window, document);
